import React, { useState } from 'react'
import { replaceBadges } from 'lib/badges'
import { updateDataLayer } from '../../helpers'

type Props = {
  badges: Array<Record<string, any>>
}
const MAX_SHOW_ITEMS = 2

const Component = (props: Props): React.ReactElement<React.ComponentProps<any>, any> | null => {
  const { badges } = props
  const [showContent, setShowContent] = useState(false)

  if (!badges.length) {
    return null
  }

  return (
    <div data-type='badges'>
      <h6 className='defaultTypographyH6' data-type='main-title'>
        Recognition
      </h6>
      {replaceBadges(badges).map(({ image, title }, key) => {
        return (
          <div
            data-hide={!showContent && key >= MAX_SHOW_ITEMS ? 'hide' : 'show'}
            data-type='badge'
            key={title + key}
          >
            <img
              data-type='badge-image'
              className='lazyload'
              data-src={image}
              alt={`link - ${title}`}
            />
            <p className='defaultTypographyXSmall' data-type='title'>
              {title}
            </p>
          </div>
        )
      })}
      {badges.length && badges.length > MAX_SHOW_ITEMS && (
        <button
          type='button'
          data-type='view-more-button'
          onClick={() => {
            !showContent &&
              updateDataLayer({
                event: 'view more',
                label: 'badges',
              })
            setShowContent(!showContent)
          }}
        >
          {!showContent ? 'View more' : 'View less'}
        </button>
      )}
    </div>
  )
}

export default Component
